module.exports = "<span>\r\n    <button (click)=\"invokeParentMethod()\" class=\"btn btn-primary\">\r\n        <i class=\"fa fa-download\"></i>\r\n    </button>\r\n</span>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/A2-utils/grid-components/claim-button/claim-button.component.html
// module id = 2331
// module chunks = 66